module.exports = __webpack_public_path__ + "static/media/017_v2_dashboard_firstuse.27dccc72.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/docker/017_v2_dashboard_firstuse.png
// module id = 396
// module chunks = 0